import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { List, Bug } from "@phosphor-icons/react";
import AIConfig from "@/components/ai-config";
import { ThemeToggleButton } from "@/components/theme-toggle";
import { DebugConsole } from "@/components/debug-console";
import { MenuItem, MenuSection } from "./";
export function MenuDropdown() {
  const $ = _c(6);
  const [showDebugConsole, setShowDebugConsole] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DropdownMenuTrigger asChild={true} className="outline-0! ring-0! focus:outline-0! focus:ring-0!"><Button variant="ghost" size="icon" className="shrink-0 h-11 w-11 rounded-lg hover:bg-muted"><List className="w-5 h-5 text-muted-foreground" /></Button></DropdownMenuTrigger>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MenuSection title="Appearance"><div className="px-2 py-1 flex justify-start"><ThemeToggleButton /></div></MenuSection>;
    t2 = <DropdownMenuSeparator className="my-1" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DropdownMenu>{t0}<DropdownMenuContent className="w-80 rounded-xl p-1" align="start" sideOffset={8}>{t1}{t2}<MenuSection title="Tools"><MenuItem icon={Bug} label="Debug Console" onClick={() => setShowDebugConsole(true)} /></MenuSection><DropdownMenuSeparator className="my-1" /><AIConfig /></DropdownMenuContent></DropdownMenu>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== showDebugConsole) {
    t4 = <>{t3}<DebugConsole isOpen={showDebugConsole} onOpenChange={setShowDebugConsole} /></>;
    $[4] = showDebugConsole;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}